/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcPoolOrgRequestStatusQuota { 
    /**
     * The end date of SDDC hours usage
     */
    sddc_hours_end_date?: Date;
    /**
     * The limit of SDDC hours allowed
     */
    sddc_hours_limit?: number;
    /**
     * The start date of SDDC hours usage
     */
    sddc_hours_start_date?: Date;
    /**
     * The usage of SDDC in hours
     */
    sddc_hours_usage?: number;
    /**
     * The date when SDDC hours usage was computed
     */
    sddc_hours_usage_computed_date?: Date;
}

